import React, { useEffect, useState } from 'react'
import { Compass, Ship, ArrowRight, MessageSquare } from 'lucide-react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { ChevronLeft } from 'lucide-react';

import "swiper/css";
import "swiper/css/pagination";
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import { Ruler, Award, BedDouble, Wind, Users, } from 'lucide-react';
import {  CalendarCheck, Sparkles, Sliders, Music } from 'lucide-react';
import {  Maximize, ChevronRight, Heart, PawPrint } from "lucide-react";
import {  Film,  MapPin, Anchor, Star } from "lucide-react";
// import {    Sunset } from 'lucide-react';
import {    Shield } from 'lucide-react';

import FAQSection from '../Components/FAQSection';
import IndiaBoatsTopBar from '../Components/IndiaBoatsTopBar';
import PremiumNavbar from '../Components/PremiumNavbar';
import { useNavigate } from 'react-router-dom';
import { getMainImageUrl } from '../utils/fleetCardMedia';
import { getYachtDetailsPath } from '../utils/fleetCardSlug';
import SEO from '../Components/SEO';
import { SEO_DATA } from '../config/seoData';

const ypFaqs = [
  {
    question: "Can I book a specific yacht by name for a yacht party in Mumbai?",
    answer: "Yes. This page displays actual yacht names from the database so guests can browse, compare, and book a specific yacht directly."
  },
  {
    question: "Will each yacht card have a direct booking link?",
    answer: "Yes. Each yacht listing card includes a direct 'Book Now' link along with a 'View Details' option to streamline your reservation process."
  },
  {
    question: "What information should each yacht card show?",
    answer: "Each card shows the specific yacht name, real image, size dimensions, guest capacity, a short entertainment-focused description, and a direct booking link."
  },
  {
    question: "Can I compare yachts by size and guest capacity?",
    answer: "Yes. The page is designed to help guests easily compare yacht options side-by-side based on size, guest capacity, and celebration suitability."
  },
  {
    question: "Are these yacht party options suitable for birthdays and anniversaries?",
    answer: "Yes. Yacht parties in Mumbai are a highly popular choice for premium milestone birthdays, romantic anniversaries, and elite private celebrations."
  },
  {
    question: "Can I book a yacht for a small private group?",
    answer: "Yes. Smaller yacht and compact cruiser options are ideal for intimate celebrations, close friend group gatherings, and private family dinners."
  },
  {
    question: "Is a yacht party in Mumbai safe?",
    answer: "Yes. Indiaboats places a strong emphasis on a highly trained marine crew, constant guest support, and completely responsible, certified operations."
  },
  {
    question: "How do I enquire if I am not sure which yacht to choose?",
    answer: "You can instantly contact Indiaboats through the on-page enquiry form or via WhatsApp with your target date, guest count, and celebration type for personalized recommendations."
  }
];

 const mumbaiCategories = [
  {
    id: "01",
    title: "Classic Party Sailer",
    category: "Party Sailboats",
    capacity: "Up to 6 Guests",
    dimensions: "18 to 24 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Intimate Birthday Soirees",
    desc: "An elegant, open-air sailing platform curated specifically for intimate birthday surprises, dynamic anniversary toasts, and high-end private sundowners under the cinematic backdrop of the Mumbai harbor skyline.",
    imgUrl: "assets/img/yachtparties1_resize.png",
    type: "Bespoke Open-Water Soiree"
  },
  {
    id: "02",
    title: "Sunset Lounge Mini Yacht",
    category: "Compact Party Yachts",
    capacity: "Up to 6 Guests",
    dimensions: "18 to 24 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Private Champagne Toasts",
    desc: "A sleek and compact luxury yacht featuring an ambient sound setup and custom deck configurations, ideal for VIP couples or close friend groups looking to host premium pre-party mixers on the water.",
    imgUrl: "assets/img/yachtparties2.png",
    type: "VIP Sunset Pre-Game"
  },
  {
    id: "03",
    title: "Vanguard Celebration Cruiser",
    category: "Mid-Size Party Yachts",
    capacity: "Up to 8 Guests",
    dimensions: "25 to 30 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Bachelor & Bachelorette Warmups",
    desc: "A beautifully balanced luxury cruiser boasting a wide-beam entertainment deck and dynamic multi-colored marine lighting, making it the top choice for hosting unforgettable milestone celebrations and elite family reunions.",
    imgUrl: "assets/img/pyc3.JPG",
    type: "High-Energy Social Cruiser"
  },
  {
    id: "04",
    title: "Premium Sky-Deck Yacht",
    category: "Premium Party Yachts",
    capacity: "Up to 12 Guests",
    dimensions: "30 to 38 feet",
    cabins: "2 Cabins",
    washroom: "1 Washroom",
    goodFor: "Elite Birthday Bashes",
    desc: "A spectacular multi-cabin luxury yacht optimized for premium entertainment, offering custom integration for gourmet catering layouts and deep lounge seating for high-profile social gatherings and upscale yacht parties.",
    imgUrl: "assets/img/pyc4.JPG",
    type: "Ultra-Premium Luxury Gala Layout"
  },
  {
    id: "05",
    title: "Grand Horizon Party Vessel",
    category: "Large Sail Yachts",
    capacity: "Up to 15 Guests",
    dimensions: "35 to 45 feet",
    cabins: "2 Cabins",
    washroom: "1 Washroom",
    goodFor: "Alumni & High-End Mixers",
    desc: "A majestic large-format sailing yacht featuring a vast teak wood deck area that allows massive flexibility for premium cocktail bars, live music setups, and deeply engaging high-society ocean networking events.",
    imgUrl: "assets/img/pyc2.JPG",
    type: "Spacious Open-Deck Carnival Format"
  }
];

const goaCategories = [
  {
    id: "g01",
    title: "Goan Breeze Party Catamaran",
    category: "Entertainment Catamarans",
    capacity: "Up to 15 Guests",
    dimensions: "40 to 45 feet",
    cabins: "2 Cabins",
    washroom: "2 Washrooms",
    goodFor: "Mandovi Island Beach Parties",
    desc: "The definitive twin-hull party destination over the Mandovi River, complete with dual-trampoline sunbathing networks, expansive dance-ready floor configurations, and robust marine speaker arrays built for serious day-parties.",
    imgUrl: "assets/img/pyc1.JPG",
    type: "Ultra-Stable Dual-Hull Festival Deck"
  },
  {
    id: "g02",
    title: "Mandovi Coastline Speed-Yacht",
    category: "High-Velocity Party Yachts",
    capacity: "Up to 8 Guests",
    dimensions: "28 to 38 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Fast-Paced Island Hopping Parties",
    desc: "A blazing fast, aggressively styled luxury speed-yacht tailored to skip corporate or private party VIP groups down to isolated Goan island keys for exclusive, secret-beach style dance activations.",
    imgUrl: "assets/img/pyc2.JPG",
    type: "Rapid VIP Champagne Shuttle"
  },
  {
    id: "g03",
    title: "Panaji Elite Double-Decker Mega Yacht",
    category: "Mega Party Yachts",
    capacity: "Up to 25 Guests",
    dimensions: "60 to 75 feet",
    cabins: "2 Cabins",
    washroom: "2 Washrooms",
    goodFor: "Large Scale Milestone Jubilees",
    desc: "An incredible two-tier floating nightlife venue specially engineered for legendary milestone birthdays, corporate product launch afterparties, and massive electronic music sunset cruises along Goan estuaries.",
    imgUrl: "assets/img/pyc3.JPG",
    type: "Dual-Level Premium Mega-Club Venue"
  },
  {
    id: "g04",
    title: "Arabian Crest Majestic Superyacht",
    category: "Superyacht Party Venues",
    capacity: "Up to 12 Guests",
    dimensions: "80+ feet",
    cabins: "4 Cabins",
    washroom: "4 Washrooms",
    goodFor: "Ultra-Luxury Billionaire Bashes",
    desc: "The absolute zenith of marine indulgence, this sprawling superyacht gives high-net-worth individuals a totally secure, ultra-private multi-deck fortress to host world-class international ocean galas and deep-sea elite parties.",
    imgUrl: "assets/img/pyc4.JPG",
    type: "Sovereign-Tier Floating Mansion Gala"
  },
  {
    id: "g05",
    title: "Vagator Premium Party Catamaran",
    category: "Luxury Deck Catamarans",
    capacity: "Up to 18 Guests",
    dimensions: "48 feet",
    cabins: "3 Cabins",
    washroom: "3 Washrooms",
    goodFor: "Golden Hour DJ Sunsets",
    desc: "An exceptional luxury deck catamaran boasting wide walk-around channels and a panoramic bridge, crafted precisely to stage breathtaking sunset sundowners, elite corporate mixers, and premium catering spreads.",
    imgUrl: "assets/img/pyc2.JPG",
    type: "Elite Open-Air Lounge Concept"
  }
];

const mumbaiCategories2 = [
  {
    id: "01",
    title: "Classic Windward Party Sailer",
    category: "Party Sailboats",
    capacity: "Up to 6 Guests",
    dimensions: "18 to 24 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Acoustic Live Music Sunsets",
    desc: "A charming, intimate sailing platform perfectly structured to host close family dinners, acoustic live-music sessions, and private storytelling cruises away from the mainland chaos.",
    imgUrl: "assets/img/pyc5.JPG",
    type: "Intimate Acoustic Ocean Lounge"
  },
  {
    id: "02",
    title: "Sunset Glow Private Charter",
    category: "Compact Party Yachts",
    capacity: "Up to 6 Guests",
    dimensions: "18 to 24 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Pre-Wedding Proposal Parties",
    desc: "A beautifully appointed compact yacht space featuring dynamic LED accent options and premium soft furnishings, making it an idyllic canvas for fairy-tale surprise marriage proposals and intimate engagement celebrations.",
    imgUrl: "assets/img/pyc6.JPG",
    type: "Bespoke Romance & Proposal Hub"
  },
  {
    id: "03",
    title: "Luxury Odyssey Celebration Yacht",
    category: "Mid-Size Party Yachts",
    capacity: "Up to 8 Guests",
    dimensions: "25 to 30 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Promotions & Milestone Drinks",
    desc: "An upscale mid-size yacht platform engineered with a spacious aft-deck social zone, allowing seamless flow for cocktail parties, luxury product previews, and high-energy career milestone celebrations.",
    imgUrl: "assets/img/pyc7.JPG",
    type: "Mid-Scale Floating Cocktail Bar"
  },
  {
    id: "04",
    title: "Premium Horizon Nightlife Cruiser",
    category: "Premium Party Yachts",
    capacity: "Up to 12 Guests",
    dimensions: "30 to 38 feet",
    cabins: "2 Cabins",
    washroom: "1 Washroom",
    goodFor: "Fashion Label & Creator Parties",
    desc: "A premier multi-level high-luxury yacht cruise optimized internally with top-tier aesthetic backdrops, high-definition audio layouts, and plush leather banquettes built for high-end fashion shoots and media wrap parties.",
    imgUrl: "assets/img/pyc8.JPG",
    type: "Media-Ready Elite Showroom"
  },
  {
    id: "05",
    title: "Grand Horizon Majestic Sail Yacht",
    category: "Large Sail Yachts",
    capacity: "Up to 15 Guests",
    dimensions: "35 to 45 feet",
    cabins: "2 Cabins",
    washroom: "1 Washroom",
    goodFor: "Themed Retro Sailing Parties",
    desc: "A massive, eye-catching luxury sailing rig featuring a massive bow footprint and expansive seating benches, making it the perfect choice for themed vintage cruises and large group beach-attire parties.",
    imgUrl: "assets/img/pyc9.JPG",
    type: "Vintage Nautical Carnival Format"
  }
];

const goaCategories2 = [
  {
    id: "g01",
    title: "Goan Breeze Electronic Catamaran",
    category: "Entertainment Catamarans",
    capacity: "Up to 15 Guests",
    dimensions: "40 to 45 feet",
    cabins: "2 Cabins",
    washroom: "2 Washrooms",
    goodFor: "Boho Electronic Music Shuttles",
    desc: "An incredible dual-hull design featuring an open bar island template, built explicitly to host energetic deep-house parties, premium corporate team mixers, and heavy sunbathing sessions across Goan bays.",
    imgUrl: "assets/img/pyc1.JPG",
    type: "High-Stability Sound System Hub"
  },
  {
    id: "g02",
    title: "Mandovi Luxury Speed-Cruiser",
    category: "High-Velocity Party Yachts",
    capacity: "Up to 8 Guests",
    dimensions: "28 to 38 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "VIP Nightlife Island Relocations",
    desc: "A streamlined, premium speed yacht curated specifically to transport elite guests and VIP artists from major Goa resorts directly to private riverine beach venues while serving cocktails onboard.",
    imgUrl: "assets/img/pyc2.JPG",
    type: "High-Speed Floating VIP Lounge"
  },
  {
    id: "g03",
    title: "Panaji Double-Decker Carnival Palace",
    category: "Mega Party Yachts",
    capacity: "Up to 25 Guests",
    dimensions: "60 to 75 feet",
    cabins: "2 Cabins",
    washroom: "2 Washrooms",
    goodFor: "Corporate Holiday & Destination Weddings",
    desc: "The ultimate entertainment vessel in North Goa, offering an incredibly massive twin-deck staging platform ideal for full band setups, custom caterers, open-concept bar islands, and large wedding celebrations.",
    imgUrl: "assets/img/pyc3.JPG",
    type: "Two-Tier Massive Festive Arena"
  },
  {
    id: "g04",
    title: "Arabian Crest Sovereign Superyacht",
    category: "Superyacht Party Venues",
    capacity: "Up to 12 Guests",
    dimensions: "80+ feet",
    cabins: "4 Cabins",
    washroom: "4 Washrooms",
    goodFor: "High-End Corporate Venture Dinners",
    desc: "An immaculate multi-deck superyacht icon presenting unprecedented oceanic luxury. Equipped with master flybridge decks and full media walls for hosting private film galas and luxury high-net-worth investor parties.",
    imgUrl: "assets/img/pyc4.JPG",
    type: "Ultra-Exclusionary Billionaire Lounge"
  },
  {
    id: "g05",
    title: "Vagator Premium Sunset Catamaran",
    category: "Luxury Deck Catamarans",
    capacity: "Up to 18 Guests",
    dimensions: "48 feet",
    cabins: "3 Cabins",
    washroom: "3 Washrooms",
    goodFor: "Luxury Pre-Wedding Mixers",
    desc: "A magnificent mega-width luxury deck catamaran meticulously designed for massive sunset champagne cruises, lavish media launch meetups, and high-end family milestone yacht parties.",
    imgUrl: "assets/img/pyc6.JPG",
    type: "Premium Multi-Tier Sunset Lounge"
  }
];

const YachtParties = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('mumbai');
  const [activeTab2, setActiveTab2] = useState('mumbai');
  const [luxuryMumbai, setLuxuryMumbai] = useState(mumbaiCategories);
  const [luxuryGoa, setLuxuryGoa] = useState(goaCategories);
  const [exploreMumbai, setExploreMumbai] = useState(mumbaiCategories2);
  const [exploreGoa, setExploreGoa] = useState(goaCategories2);
  const [fleetRevision, setFleetRevision] = useState(0);

  const getMediaUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    if (path.startsWith("/uploads/")) return path;
    return path;
  };

  const hasText = (value) => Boolean(String(value || "").trim());
  const layoutText = (card) => {
    const cabins = String(card.cabins || "").trim();
    const washroom = String(card.washroom || "").trim();
  
    const layout = [];
  
    if (cabins) {
      layout.push(`Cabin ${cabins}`);
    }
  
    if (washroom) {
      layout.push(`Washroom ${washroom}`);
    }
  
    return layout.join(" / ");
  };

  useEffect(() => {
    fetch("/api/experiences/yacht-party-mumbai")
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!data) return;
        if (data.luxuryMumbai) setLuxuryMumbai(data.luxuryMumbai);
        if (data.luxuryGoa) setLuxuryGoa(data.luxuryGoa);
        if (data.exploreMumbai) setExploreMumbai(data.exploreMumbai);
        if (data.exploreGoa) setExploreGoa(data.exploreGoa);
        setFleetRevision((value) => value + 1);
      })
      .catch((error) => console.error("Experience fetch error:", error));
  }, []);

  const activeFleet = activeTab === 'mumbai' ? luxuryMumbai : luxuryGoa;
  const activeFleet2 = activeTab2 === 'mumbai' ? exploreMumbai : exploreGoa;
    // Active filter state
  const [selectedYachtCategory, setSelectedYachtCategory] = useState('All');

  // Unique variable name holding the curated private yacht options
  const privateYachtInventory = [
    {
      id: "yacht-01",
      title: "Classic Windward Sailer",
      category: "Sail Boats",
      size: "Authentic sailing feel",
      capacity: "Up to 6 Guests",
      desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
      imgUrl: "assets/img/pyc1.JPG"
    },
    {
      id: "yacht-02",
      title: "Sunset Harborside Cruiser",
      category: "Compact Yachts",
      size: "Compact day cruiser",
      capacity: "Up to 8 Guests",
      desc: "Ideal for couples, small families and close groups looking for a private yacht rental in Mumbai with comfort and ease.",
      imgUrl: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-03",
      title: "Versatile Family Outing Yacht",
      category: "Mid Size Yachts",
      size: "Spacious versatile platform",
      capacity: "Up to 12 Guests",
      desc: "A balanced option offering more space, comfort and versatility for private outings, family leisure and special moments.",
      imgUrl: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-04",
      title: "Premium Private Yacht Cruise",
      category: "Premium Yachts",
      size: "Luxury leisure experience",
      capacity: "Up to 15 Guests",
      desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1567899378494-47b22a28c6ad?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-05",
      title: "Grand Horizon Sailing Vessel",
      category: "Bigger Sail Yachts",
      size: "Premium ocean-going sailer",
      capacity: "Up to 20 Guests",
      desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
      imgUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=600"
    }
  ];

  // Dynamically extract unique categories for filter tabs
  const filterTabsList = ['All', 'Sail Boats', 'Compact Yachts', 'Mid Size Yachts', 'Premium Yachts', 'Bigger Sail Yachts'];

  // Filter logic based on tab state
  const filteredYachtsList = selectedYachtCategory === 'All' 
    ? privateYachtInventory 
    : privateYachtInventory.filter(yacht => yacht.category === selectedYachtCategory);


     // Active state to track the highlighted category
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);

  // Unique variable name for the updated explore categories data
  const exploreYachtSegments = [
    {
      id: "01",
      title: "Classic Windward Sailer",
      category: "Sail Boats",
      size: "Authentic sailing feel",
      capacity: "Up to 6 Guests",
      desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
      imgUrl: "https://images.unsplash.com/photo-1505044157772-6ae174669140?auto=format&fit=crop&q=80&w=1000",
      icon: <Wind size={20} />,
      amenities: ["Classic Rigging", "Open Deck Lounge", "Authentic Sea Breeze"]
    },
    {
      id: "02",
      title: "Sunset Harborside Cruiser",
      category: "Compact Yachts",
      size: "Compact day cruiser",
      capacity: "Up to 8 Guests",
      desc: "Ideal for couples, small families and close groups looking for a private yacht rental in Mumbai with comfort and ease.",
      imgUrl: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=1000",
      icon: <Ship size={20} />,
      amenities: ["Sunset Saloon", "Couples Daybed", "Express Cruising"]
    },
    {
      id: "03",
      title: "Luxury Family Yacht Experience",
      category: "Mid Size Yachts",
      size: "Spacious and private format",
      capacity: "Up to 12 Guests",
      desc: "A mid size yacht rental in Mumbai designed for family outings, private leisure and premium moments on the water.",
      imgUrl: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=1000",
      icon: <Users size={20} />,
      amenities: ["Spacious Flybridge", "Multi-zone Audio", "Leisure Swim Platform"]
    },
    {
      id: "04",
      title: "Premium Private Yacht Cruise",
      category: "Premium Yachts",
      size: "Luxury leisure experience",
      capacity: "Up to 15 Guests",
      desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1567899378494-47b22a28c6ad?auto=format&fit=crop&q=80&w=1000",
      icon: <Award size={20} />,
      amenities: ["Master Suite Cabin", "Gourmet Galley", "Exclusive Crew Service"]
    },
    {
      id: "05",
      title: "Grand Horizon Sailing Vessel",
      category: "Bigger Sail Yachts",
      size: "Premium ocean-going sailer",
      capacity: "Up to 20 Guests",
      desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
      imgUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=1000",
      icon: <Compass size={20} />,
      amenities: ["Expansive Teak Decks", "High-performance Rigging", "Grand Dining Lounge"]
    }
  ];



const premiumYachtCategories = [
    {
      id: "01",
      title: "Classic Windward Sailer",
      category: "Sail Boats",
      size: "Authentic sailing feel",
      capacity: "Up to 6 Guests",
      desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
      imgUrl: "https://images.unsplash.com/photo-1505044157772-6ae174669140?auto=format&fit=crop&q=80&w=600",
      type: "Authentic Experience"
    },
    {
      id: "02",
      title: "Sunset Private Yacht Charter",
      category: "Compact Yachts",
      size: "Ideal for premium experiences",
      capacity: "Up to 10 Guests",
      desc: "A compact private yacht charter in Mumbai ideal for couples, families and small groups looking for comfort, privacy and a memorable sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=600",
      type: "Intimate Cruise"
    },
    {
      id: "03",
      title: "Luxury Family Yacht Experience",
      category: "Mid Size Yachts",
      size: "Spacious and private format",
      capacity: "Up to 12 Guests",
      desc: "A mid size yacht rental in Mumbai designed for family outings, private leisure and premium moments on the water.",
      imgUrl: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=600",
      type: "Versatile Comfort"
    },
    {
      id: "04",
      title: "Premium Private Yacht Cruise",
      category: "Premium Yachts",
      size: "Luxury leisure experience",
      capacity: "Up to 15 Guests",
      desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1567899378494-47b22a28c6ad?auto=format&fit=crop&q=80&w=600",
      type: "Signature Luxury"
    },
    {
      id: "05",
      title: "Grand Horizon Sailing Vessel",
      category: "Bigger Sail Yachts",
      size: "Premium ocean-going sailer",
      capacity: "Up to 20 Guests",
      desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
      imgUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=600",
      type: "Grand Voyage"
    }
  ];

  
  return (

    
    <>
       <SEO {...SEO_DATA.yachtPartyMumbai} />
       <IndiaBoatsTopBar/>
      <PremiumNavbar/>

 {/* <section className="idx-section" id="destination-sec">


          <div className="idx-video-container" style={{ backgroundImage: `url('assets/img/pyc7.jpg')` }}>
            
            <div className="idx-overlay" />
          </div>

          <div className="idx-container">
            <div className="idx-header">
           <h1 className="idx-title" style={{ color: '#fff',textAlign: 'center' }}>
               Private Yacht Charters
              </h1>
              <section className="idx-pillar-wrapper1">
                <div className="container">
                 </div>
              </section>
  </div>

          
          </div>


        </section> */}
          <div className="ib-page-wrapper">
             <div className="aeb-page-section-one">   
      
    

   <section className="lyc-main-section" id='yacht_parties_section'>
      <div className="lyc-container lyc-section-container">
        
        {/* Navigation Tab Header Row */}
        <div className="lyc-header-navigation-block">
          <h1 className="idx-title" style={{ textAlign: 'center' }}>
               Yacht Parties  
              </h1>
              <div className="lyc-tabs-wrapper">
            
            <button 
              className={`lyc-tab-btn ${activeTab === 'mumbai' ? 'active' : ''}`}
              onClick={() => setActiveTab('mumbai')}
            >
              <MapPin size={14} />
              <span>Mumbai</span>
            </button>
            <button 
              className={`lyc-tab-btn ${activeTab === 'goa' ? 'active' : ''}`}
              onClick={() => setActiveTab('goa')}
            >
              <MapPin size={14} />
              <span>Goa </span>
            </button>
          </div>
          <div className="fleet_toggle">
            <div className="epyo-badge-row">
            <Anchor size={18} className="epyo-badge-icon" />
            <span className="epyo-pre-title">Luxury Fleet</span>
          </div>
          
          </div>
          {/* <div className="lyc-title-divider"></div> */}
        </div>

        {/* Swiper Slider Component */}
        <div className="lyc-swiper-wrapper" style={{ position: 'relative' }}>
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={20}
        slidesPerView={4}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        navigation={{
          prevEl: ".lyc-swiper-prev-luxury",
          nextEl: ".lyc-swiper-next-luxury",
        }}
        breakpoints={{
          320: { slidesPerView: 1.25 },
          576: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
        className="lyc-swiper-instance"
        style={{ padding: '10px 10px' }}
        key={`luxury-${activeTab}-${fleetRevision}-${activeFleet.length}`}
      >
        {activeFleet.map((category) => (
          <SwiperSlide key={category._id || category.id}>
            <div className="lyc-card-v2">
              <div className="lyc-card-top-accent"></div>

              {/* Vertical Image Wrapper */}
              <div className="lyc-image-wrapper-v2">
                <img
                  src={getMediaUrl(getMainImageUrl(category))}
                  alt={category.title}
                  className="lyc-card-img-v2"
                />
                <div className="lyc-img-overlay"></div>
              </div>

              {/* Content Area */}
              <div className="lyc-card-content-v2">
                <div className="lyc-card-header">
                  <h3 className="lyc-card-title-v2">{category.title || category.category}</h3>
                  <span className="lyc-card-subtitle-tag">{category.type}</span>
                </div>

                {/* Expanded Specifications List */}
                <div className="lyc-card-specs-v2">
                  {hasText(category.desc) && (
                    <p className="lyc-card-desc">{category.desc}</p>
                  )}

                  {hasText(category.capacity) && (
                    <div className="lyc-spec-row-v2">
                      <Users size={18} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Guests:</span>
                      <span className="lyc-spec-val">{category.capacity}</span>
                    </div>
                  )}

                  {hasText(category.dimensions) && (
                    <div className="lyc-spec-row-v2">
                      <Ship size={18} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Size:</span>
                      <span className="lyc-spec-val">{category.dimensions}</span>
                    </div>
                  )}

                  {layoutText(category) && (
                    <div className="lyc-spec-row-v2">
                      <BedDouble size={18} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Layout:</span>
                      <span className="lyc-spec-val">{layoutText(category)}</span>
                    </div>
                  )}

                  {hasText(category.goodFor) && (
                    <div className="lyc-spec-row-v2">
                      <Sparkles size={18} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Good For:</span>
                      <span className="lyc-spec-val">{category.goodFor}</span>
                    </div>
                  )}

                  {category.petFriendly && (
                    <div className="lyc-spec-row-v2">
                      <PawPrint size={14} className="epyo-metric-icon" />
                      <span className="epyo-metric-text">Pet Friendly</span>
                    </div>
                  )}
                </div>

                {/* Sleek Premium Button */}
                <div className="lyc-card-footer-v2">
                  <button
                    type="button"
                    className="lyc-sleek-btn"
                    onClick={() => {
                      if (category._id) {
                        navigate(getYachtDetailsPath(category));
                      }
                    }}
                  >
                    <span className="lyc-btn-text">Book Now</span>
                    <span className="lyc-btn-icon-wrap">
                      <ChevronRight size={16} className="lyc-arrow-icon" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Unique Navigation Buttons for the Luxury Slider */}
      <button type="button" className="lyc-swiper-prev-luxury" aria-label="Previous Slide">
        <ChevronLeft size={20} />
      </button>
      <button type="button" className="lyc-swiper-next-luxury" aria-label="Next Slide">
        <ChevronRight size={20} />
      </button>
    </div>

      </div>
    </section>
     
      </div>

      <section className="lyc-main-section" id='explore_yp_lyc_section'>
            <div className="lyc-container lyc-section-container">
              
              {/* Navigation Tab Header Row */}
              <div className="lyc-header-navigation-block">
                
                <div className="lyc-tabs-wrapper">
                  <button 
                    className={`lyc-tab-btn ${activeTab2 === 'mumbai' ? 'active' : ''}`}
                    onClick={() => setActiveTab2('mumbai')}
                  >
                    <MapPin size={14} />
                    <span>Mumbai</span>
                  </button>
                  <button 
                    className={`lyc-tab-btn ${activeTab2 === 'goa' ? 'active' : ''}`}
                    onClick={() => setActiveTab2('goa')}
                  >
                    <MapPin size={14} />
                    <span>Goa </span>
                  </button>
                </div>
                <div className="epyo-badge-row">
                  <Anchor size={14} className="epyo-badge-icon" />
                  <span className="epyo-pre-title">Explore Fleet</span>
                </div>
              </div>
      
              {/* Swiper Slider Component */}
              <div className="lyc-swiper-wrapper" style={{ position: 'relative' }}>
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={20}
        slidesPerView={4}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        navigation={{
          prevEl: ".lyc-swiper-prev-explore",
          nextEl: ".lyc-swiper-next-explore",
        }}
        breakpoints={{
          320: { slidesPerView: 1.25 },
          576: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
        className="lyc-swiper-instance"
        style={{ padding: '10px 10px' }}
        key={`explore-${activeTab2}-${fleetRevision}-${activeFleet2.length}`}
      >
        {activeFleet2.map((category) => (
          <SwiperSlide key={category._id || category.id}>
            <div className="lyc-card-v2">
              <div className="lyc-card-top-accent"></div>

              {/* Vertical Image Wrapper */}
              <div className="lyc-image-wrapper-v2">
                <img
                  src={getMediaUrl(getMainImageUrl(category))}
                  alt={category.title}
                  className="lyc-card-img-v2"
                />
                <div className="lyc-img-overlay"></div>
              </div>

              {/* Content Area */}
              <div className="lyc-card-content-v2">
                <div className="lyc-card-header">
                  <h3 className="lyc-card-title-v2">{category.title || category.category}</h3>
                  <span className="lyc-card-subtitle-tag">{category.type}</span>
                </div>

                {/* Expanded Specifications List */}
                <div className="lyc-card-specs-v2">

                {hasText(category.desc) && (
                  <p className="lyc-card-desc">{category.desc}</p>
                )}
                
                  {hasText(category.capacity) && (
                    <div className="lyc-spec-row-v2">
                      <Users size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Guests:</span>
                      <span className="lyc-spec-val">{category.capacity}</span>
                    </div>
                  )}

                  {hasText(category.dimensions) && (
                    <div className="lyc-spec-row-v2">
                      <Maximize size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Size:</span>
                      <span className="lyc-spec-val">{category.dimensions}</span>
                    </div>
                  )}

                  {layoutText(category) && (
                    <div className="lyc-spec-row-v2">
                      <Compass size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Layout:</span>
                      <span className="lyc-spec-val">{layoutText(category)}</span>
                    </div>
                  )}

                  {hasText(category.goodFor) && (
                    <div className="lyc-spec-row-v2">
                      <Heart size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Good For:</span>
                      <span className="lyc-spec-val">{category.goodFor}</span>
                    </div>
                  )}

                  {category.petFriendly && (
                    <div className="lyc-spec-row-v2" style={{ marginLeft: '6px' }}>
                      <PawPrint size={14} className="epyo-metric-icon" />
                      <span className="epyo-metric-text">Pet Friendly</span>
                    </div>
                  )}
                </div>

               

                {/* Sleek Premium Button */}
                <div className="lyc-card-footer-v2">
                  <button
                    type="button"
                    className="lyc-sleek-btn"
                    onClick={() => {
                      if (category._id) {
                        navigate(getYachtDetailsPath(category));
                      }
                    }}
                  >
                    <span className="lyc-btn-text">Book Now</span>
                    <span className="lyc-btn-icon-wrap">
                      <ChevronRight size={16} className="lyc-arrow-icon" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Unique Navigation Buttons */}
      <button type="button" className="lyc-swiper-prev-explore" aria-label="Previous Slide">
        <ChevronLeft size={20} />
      </button>
      <button type="button" className="lyc-swiper-next-explore" aria-label="Next Slide">
        <ChevronRight size={20} />
      </button>
    </div>
      
            </div>
          </section>


    <section className="ib-luxury-feature-wrapper">
  <div className="ib-luxury-feature-container">
    <div className="ib-luxury-feature-main-content">
      <h2 className="ib-luxury-feature-headline">
        Why Choose Indiaboats for Yacht Parties
      </h2>
      <p>
        <span className="ib-luxury-feature-text-accent">Indiaboats</span> 
        offers bookable yacht party options in Mumbai, making it easy to browse real yachts by name, compare guest capacity and choose the right celebration venue on the water. Whether you are planning a birthday, anniversary, family gathering or private event, this page helps you move quickly from browsing to booking.
      </p>
     
    </div>

   <div className="ib-luxury-feature-grid">
  {[
    { 
      title: "Bookable Party Fleets", 
      desc: "Fully bookable premium yacht party packages in Mumbai, meticulously pre-configured with top-tier decor layouts, custom marine setups, and ocean-optimized sound rigs.", 
      icon: <Music size={24} /> 
    },
    { 
      title: "Live Vessel Listings", 
      desc: "Instant access to real, live yacht listings in Mumbai—featuring iconic named vessels like the Ferretti 550, MacGregor 26, and premium Majesty luxury yachts.", 
      icon: <Ship size={24} /> 
    },
    { 
      title: "Milestone Celebrations", 
      desc: "Exquisitely tailored spaces perfect for hosting high-end birthday bashes, romantic anniversary dinners, surprise marriage proposals, and dynamic private social gatherings.", 
      icon: <Sparkles size={24} /> 
    },
    { 
      title: "Adaptive Crew Capacities", 
      desc: "A vast spectrum of yacht sizes engineered seamlessly to accommodate any guest list, scaling from intimate 6-guest charters up to massive 25+ deck celebrations.", 
      icon: <Sliders size={24} /> 
    },
    { 
      title: "Premium Water Experience", 
      desc: "Immersive open-water luxury featuring service-first hospitality, tailored gourmet catering arrangements, and panoramic twilight views over the Gateway of India.", 
      icon: <Compass size={24} /> 
    },
    { 
      title: "Direct Booking Flow", 
      desc: "An effortless browsing interface paired with a streamlined checkout system, allowing you to instantly secure live real-time scheduling slots and hassle-free locks.", 
      icon: <CalendarCheck size={24} /> 
    }
  ].map((item, index) => (
    <div key={index} className="ib-luxury-feature-card">
      <div className="ib-luxury-feature-icon-box">{item.icon}</div>
      <div className="ib-luxury-feature-card-content">
        <h4>{item.title}</h4>
        <p>{item.desc}</p>
      </div>
    </div>
  ))}
</div>
  </div>
</section>

      

  <section className="pfUniqueMainSection">
  <div className="pfUniqueContainer">
    
    {/* Section Header */}
    <div className="pfUniqueHeader" style={{ marginBottom: '2rem' }}>
      <h2 className="pfUniqueHeading">
        Perfect For
      </h2>
    </div>

    {/* Main Content Grid */}
   <div className="pfUniqueGridWrapper">
  {[
    "Birthday yacht party in Mumbai",
    "Anniversary yacht celebration",
    "Family yacht parties",
    "Private celebration events",
    "Small group social gatherings",
    "Premium party yacht experiences",
    
  ].map((item, index) => (
    <div className="pfUniqueCardBox" key={index}>
      <div className="pfUniqueCheckIcon">✓</div>
      <p className="pfUniqueCardText">{item}</p>
    </div>
  ))}
</div>
  </div>
</section>



      

   <section className="wteUniqueMainSection">
  <div className="wteUniqueContainer">
    <div className="wteUniqueContentWrapper">
      <div className="wteUniqueLeftContent">
        <span className="wteUniqueMiniTitle">
          WHAT TO EXPECT
        </span>

        <h2 className="wteUniqueHeading">
          What to Expect with <span>Indiaboats</span>
        </h2>

        <p className="wteUniqueParagraph">
        Each yacht party listing on this page helps you explore real, bookable yacht options in Mumbai based on yacht name, group size and celebration type. Indiaboats makes the booking process simple, clear and convenient.
        </p>
      </div>

      <div className="wteUniqueRightContent">
        {[
          "Real yacht listings ",
          "Bookable yacht party options",
          "Visible size and guest capacity",
          "Private celebration setting",
          "Comfortable private setting",
          "Suitable for different event types",
          "Booking assistance and coordination",
          "Safety briefing and support"
        ].map((item, index) => (
          <div className="wteUniqueListCard" key={index}>
            <div className="wteUniqueCheckCircle">✓</div>
            <p className="wteUniqueListText">{item}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

     <section className="scUniqueMainSection">
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Comfort and <span>Service</span>
          </h2>

          <p className="scUniqueParagraph">
         At Indiaboats, safety is central to every yacht party experience. We place strong emphasis on trained crew, responsible operations, guest comfort and smooth coordination so every yacht party in Mumbai is both enjoyable and professionally managed.
          </p>
        </div>
      </div>
    </section>

    <FAQSection
  pageKey="yacht-party-mumbai"
  title="Frequently Asked Questions About Yacht Party Mumbai"
  faqData={ypFaqs}
/>

 {/* <section className="igxMainCtaSection">
      <div className="igxMainCtaContainer">
        <div className="igxGlassCardWrapper">

        

          <h2 className="igxMainHeading">
           Book Your <span>Private Yacht Charter</span> in Mumbai
          </h2>

          <p className="igxParagraphText">
          Browse available yacht party options by yacht name, size and guest capacity to find the right yacht for your next celebration in Mumbai.
          </p>

          <div className="igxButtonFlex">

            <button className="igxPrimaryActionBtn">
              <span>Book a Yacht Party </span>
            </button>

            <button className="igxOutlineActionBtn">
              <span>Enquire on WhatsApp</span>
            </button>

            <button className="igxWhatsappActionBtn">
              <span>Request a Quote</span>
            </button>

          </div>
        </div>
      </div>
    </section>

     <section className="btfUniqueSection">
      <div className="btfUniqueContainer">

        <div className="btfUniqueFormCard">

          <div className="btfUniqueTopContent">
            <h2 className="btfUniqueHeading">
              Tell Us About Your  <span>Celebration</span>
             
            </h2> 
 
            <p className="btfUniqueParagraph">
              Share your preferred destination, group size and travel
              requirement and our team will help you plan the right
              private boat experience.
            </p>
          </div>

       <form className="btfUniqueFormWrapper">
  <div className="btfUniqueInputGrid">
    
    <div className="btfUniqueFieldBox">
      <label>Name</label>
      <input type="text" placeholder="Enter your name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Mobile Number</label>
      <input type="tel" placeholder="Enter mobile number" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Email Address</label>
      <input type="email" placeholder="Enter email address" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Preferred Date</label>
      <input type="date" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Number of Guests</label>
      <input type="number" placeholder="Number of guests" />
    </div>

  <div className="btfUniqueFieldBox">
  <label>Occasion</label>
  <input type="text" placeholder="e.g. Birthday, Anniversary, Private Celebration" />
</div>

<div className="btfUniqueFieldBox">
  <label>Preferred Yacht Category</label>
  <select>
    <option value="">Select yacht category</option>
    <option value="sail-boat">Sail Boat</option>
    <option value="compact-yacht">Compact Yacht</option>
    <option value="mid-size-yacht">Mid-Size Yacht</option>
    <option value="premium-yacht">Premium Yacht</option>
    <option value="large-sail-yacht">Bigger Sail Yacht</option>
  </select>
</div>

  </div>

  <div className="btfUniqueFieldBox btfUniqueTextareaBox">
    <label>Requirement Details</label>
    <textarea
      rows="6"
      placeholder="Tell us more about your private party requirements..."
    ></textarea>
  </div>

  <button
    type="submit"
    className="btfUniqueSubmitButton"
  >
    <span>Request a Quote</span>
  </button>
</form>
        </div>
      </div>
    </section> */}

            </div>


<Footer/>
</>
  )
}

export default YachtParties
